import React from "react";
import styles from "../style.module.css";
import { RxCrossCircled } from "react-icons/rx";
import {
  Table,
  TableContainer,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";

const Upcoming = ({ notification }) => {
  function formatDate(inputDate) {
    const date = new Date(inputDate);
    const options = {
      year: "numeric",
      month: "long",
      day: "numeric",
    };

    // Get the day, month, and year parts from the date
    const day = date.getDate();
    const month = date.toLocaleDateString("en-US", { month: "long" });
    const year = date.getFullYear();

    // Function to add "st", "nd", "rd", or "th" to the day
    function getDayWithSuffix(day) {
      if (day >= 11 && day <= 13) {
        return day + "th";
      }
      switch (day % 10) {
        case 1:
          return day + "st";
        case 2:
          return day + "nd";
        case 3:
          return day + "rd";
        default:
          return day + "th";
      }
    }

    const formattedDate = getDayWithSuffix(day) + " " + month + ", " + year;
    return formattedDate;
  }
  function formatCustomDate(inputDate) {
    const date = new Date(inputDate);

    const options = {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
    };

    // Function to add "st", "nd", "rd", or "th" to the day
    function getDayWithSuffix(day) {
      if (day >= 11 && day <= 13) {
        return day + "th";
      }
      switch (day % 10) {
        case 1:
          return day + "st";
        case 2:
          return day + "nd";
        case 3:
          return day + "rd";
        default:
          return day + "th";
      }
    }

    // Format the time in 24-hour format (without AM/PM)
    const formattedTime = date.toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "numeric",
      hour12: false, // Set to false for 24-hour format
    });

    const formattedDate =
      getDayWithSuffix(date.getDate()) +
      " " +
      date.toLocaleDateString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
      }) +
      " " +
      formattedTime;

    return formattedDate;
  }

  return (
    <div className={styles.tableDiv}>
      <TableContainer
        style={{ border: "1px solid #D9E1E7", borderRadius: "20px" }}
      >
        <Table variant="simple">
          <Thead>
            <Tr>
              
              <Th style={{ textTransform:"capitalize" }}>Title</Th>
              <Th style={{ textTransform:"capitalize" }}>Message Body</Th>
              <Th style={{ textTransform:"capitalize" }}>Release on</Th>
              <Th style={{ textTransform:"capitalize" }}>Created Date</Th>
              <Th style={{ textTransform:"capitalize" }}>Status</Th>
              <Th style={{ textTransform:"capitalize" }}>Actions</Th>
            </Tr>
          </Thead>
          <Tbody>
            {notification.map((el, i) => (
              <Tr key={i}>
               
                <Td>{el.title}</Td>
                <Td>{el.body}</Td>
                <Td>{formatDate(el.releaseDate)}</Td>
                <Td>{formatCustomDate(el.createdAt)}</Td>
                <Td>{el.status}</Td>
                <Td>
                  <div className={styles.actionDiv}>
                    <span className={styles.blackBtn3}>
                      <RxCrossCircled fontSize={20} /> Cancel
                    </span>
                  </div>
                </Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </TableContainer>
    </div>
  );
};

export default Upcoming;
